document.addEventListener('DOMContentLoaded', function() {
  const productComponent = document.querySelector('product-component');
  if (!productComponent) return;

  const productThumbs = productComponent.querySelector('.product__thumbs');
  const productSlides = productComponent.querySelector('.product__slides');
  const productImages = productComponent.querySelector('product-images');
  const variantInputs = productComponent.querySelectorAll('input[data-single-option-selector]');
  
  if (!productThumbs || !productSlides) return;

  // Store original thumbnail data only
  const originalThumbs = Array.from(productThumbs.querySelectorAll('.product__thumb'));
  const originalSlides = Array.from(productSlides.querySelectorAll('[data-media-id]'));
  let currentFilteredMediaIds = [];
  let currentImageIndex = 0; // Track current position within filtered set
  
  function filterThumbnailsByVariant() {
    const selectedValues = [];
    
    // Get all selected variant option values
    variantInputs.forEach(input => {
      if (input.checked || input.type === 'hidden') {
        selectedValues.push(input.value.toLowerCase());
      }
    });

    // Check if any images have alt text matching variant values
    const hasAltImages = originalSlides.some(slide => {
      const img = slide.querySelector('img');
      return img && img.alt && selectedValues.some(value => 
        img.alt.toLowerCase().includes(value)
      );
    });

    if (!hasAltImages) {
      // Show all thumbnails if no alt text matches
      currentFilteredMediaIds = originalSlides.map(slide => slide.getAttribute('data-media-id'));
      showAllThumbnails();
      return;
    }

    // Filter and show only matching thumbnails
    const matchingThumbs = [];
    const matchingMediaIds = [];

    originalSlides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      const thumb = originalThumbs[index];
      
      if (img && img.alt && selectedValues.some(value => 
        img.alt.toLowerCase().includes(value)
      )) {
        matchingThumbs.push(thumb);
        matchingMediaIds.push(slide.getAttribute('data-media-id'));
      }
    });

    currentFilteredMediaIds = matchingMediaIds;
    updateThumbnailDisplay(matchingThumbs);
    
    // Maintain position or select first image
    if (matchingMediaIds.length > 0) {
      // Keep same index position, but don't exceed available images
      const targetIndex = Math.min(currentImageIndex, matchingMediaIds.length - 1);
      productThumbs.dispatchEvent(new CustomEvent('theme:media:select', {
        bubbles: true,
        detail: { id: matchingMediaIds[targetIndex] }
      }));
    }
  }

  function showAllThumbnails() {
    updateThumbnailDisplay(originalThumbs);
  }

  function updateThumbnailDisplay(thumbs) {
    // Clear current thumbnails only
    const thumbsHolder = productThumbs.querySelector('.product__thumbs__holder');
    thumbsHolder.innerHTML = '';

    // Add filtered thumbnails
    thumbs.forEach((thumb, index) => {
      const thumbClone = thumb.cloneNode(true);
      
      // Handle thumbnail click properly like original product-thumbs.js
      const thumbLink = thumbClone.querySelector('[data-thumb-link]');
      if (thumbLink) {
        thumbLink.addEventListener('click', function(e) {
          e.preventDefault();
          const mediaId = this.getAttribute('data-media-id');
          const thumbItem = this.closest('[data-thumb-item]');
          
          if (mediaId && thumbItem && !thumbItem.classList.contains('is-active')) {
            // Update tracked position when thumbnail is clicked
            const currentThumbs = Array.from(productThumbs.querySelectorAll('[data-thumb-link]'));
            const clickedIndex = currentThumbs.findIndex(thumb => thumb.getAttribute('data-media-id') === mediaId);
            if (clickedIndex !== -1) {
              currentImageIndex = clickedIndex;
            }
            
            // Dispatch the theme:media:select event like original
            productThumbs.dispatchEvent(new CustomEvent('theme:media:select', {
              bubbles: true,
              detail: { id: mediaId }
            }));
          }
        });
      }
      
      thumbsHolder.appendChild(thumbClone);
    });

    // Clean up unused preload links to prevent console warnings
    cleanupUnusedPreloads();

    // Reinitialize thumbnail functionality
    if (window.customElements.get('product-thumbs')) {
      const thumbsComponent = productThumbs.closest('product-thumbs');
      if (thumbsComponent && thumbsComponent.disconnectedCallback) {
        thumbsComponent.disconnectedCallback();
      }
      if (thumbsComponent && thumbsComponent.connectedCallback) {
        thumbsComponent.connectedCallback();
      }
    }
  }

  function addNavigationOverride() {
    // Override slider navigation buttons
    const sliderPrevButtons = productComponent.querySelectorAll('.slider__button--prev, .slider__button.slider__button--prev');
    const sliderNextButtons = productComponent.querySelectorAll('.slider__button--next, .slider__button.slider__button--next');
    
    // Override slider prev buttons
    sliderPrevButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateWithinFiltered(false);
      }, true);
    });
    
    // Override slider next buttons
    sliderNextButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateWithinFiltered(true);
      }, true);
    });

    // Override keyboard navigation
    productImages.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        navigateWithinFiltered(e.key === 'ArrowRight');
      }
    });
  }

  function navigateWithinFiltered(forward) {
    const currentActiveMedia = productImages.getAttribute('data-active-media');
    
    // Get media IDs from current thumbnail display order
    const currentThumbs = Array.from(productThumbs.querySelectorAll('[data-thumb-link]'));
    const currentDisplayMediaIds = currentThumbs.map(thumb => thumb.getAttribute('data-media-id'));
    
    const currentIndex = currentDisplayMediaIds.indexOf(currentActiveMedia);
    
    if (currentIndex === -1) return;
    
    let nextIndex;
    if (forward) {
      nextIndex = currentIndex === currentDisplayMediaIds.length - 1 ? 0 : currentIndex + 1;
    } else {
      nextIndex = currentIndex === 0 ? currentDisplayMediaIds.length - 1 : currentIndex - 1;
    }
    
    // Update tracked position
    currentImageIndex = nextIndex;
    
    const nextMediaId = currentDisplayMediaIds[nextIndex];
    
    // Dispatch the theme:media:select event properly
    productThumbs.dispatchEvent(new CustomEvent('theme:media:select', {
      bubbles: true,
      detail: { id: nextMediaId }
    }));
  }

  function cleanupUnusedPreloads() {
    // Get currently visible image sources
    const visibleImages = Array.from(productThumbs.querySelectorAll('img')).map(img => img.src);
    const mainImages = Array.from(productSlides.querySelectorAll('img')).map(img => img.src);
    const allVisibleSources = [...visibleImages, ...mainImages];
    
    // Remove preload links for images not currently visible
    const preloadLinks = document.querySelectorAll('link[rel="preload"][as="image"]');
    preloadLinks.forEach(link => {
      if (!allVisibleSources.some(src => link.href.includes(src.split('?')[0].split('/').pop()))) {
        link.remove();
      }
    });
  }

  // Set up navigation override once
  addNavigationOverride();

  // Listen for variant changes
  variantInputs.forEach(input => {
    input.addEventListener('change', filterThumbnailsByVariant);
  });

  // Initial filter on page load
  filterThumbnailsByVariant();
});